// extracted by mini-css-extract-plugin
module.exports = {"l1j50uzd":"l1j50uzd"};